import { useEffect, useState } from 'react';
import {
  PIE, PIE_GRADE, BAR, LINE, FUNNEL, TREE_MAP, SIMPLE_BUBBLE, GRAPH_BUBBLE,
} from '../../components/Charts/types';
import { SIMPLE_CARD, MULTIPLE_CARD, SIMPLECROSS_CARD, CORRELATION_CARD } from '../../sections/GroupCards/cardTypes';

// Este hook customizável foi desenvolvido para obter as series
// dos gráficos no componente card. Até o momento está sendo
// utilizado apenas no gráfico simples, porém futuramente os gráficos
// de grade serão implementados nos outros tipos de card.

function parseChartRefToOptions(chartRef) {
  // A primeira verificação ainda é pro caso do gráfico de barras horizontais
  // porque a forma como o gráfico é referenciado ainda não foi refatorada.
  const parsedOptions = Array.isArray(chartRef)
    ? chartRef.map((instance) => instance.props.option)
    : chartRef.props.option;
  return parsedOptions;
}

// Para os gráficos de correlação (treemap, bubble simples e graph bubble), a "série"
// relevante para os ThemeManagers e para o pipeline de cores é a lista ordenada de
// perguntas correlacionadas. Por convenção, o `toEchartOption` de cada um deles
// armazena essa lista canônica em `option.legend.data` — exatamente como o treemap.
// Cada item expõe `name` para permitir o cálculo por enunciado em `calculateChartColorsArray`.
function getCorrelationPerguntasSeries(option) {
  if (!option || !option.legend || !Array.isArray(option.legend.data)) {
    return [];
  }
  return option.legend.data.map((perguntaEnunciado) => ({ name: perguntaEnunciado }));
}

const seriesStrategies = {
  [`${SIMPLE_CARD}${PIE}`]: (option) => option.series[0].data,
  [`${SIMPLE_CARD}${PIE_GRADE}`]: (option) => option.series[0].data,
  [`${SIMPLE_CARD}${FUNNEL}`]: (option) => option.series[0].data,
  [`${MULTIPLE_CARD}${PIE}`]: (option) => option.series[0].data,
  [`${SIMPLECROSS_CARD}${BAR}`]: (option) => option[0] && option[0].series,
  [`${CORRELATION_CARD}${TREE_MAP}`]: getCorrelationPerguntasSeries,
  [`${CORRELATION_CARD}${SIMPLE_BUBBLE}`]: getCorrelationPerguntasSeries,
  [`${CORRELATION_CARD}${GRAPH_BUBBLE}`]: getCorrelationPerguntasSeries,
  default: (option) => option.series,
};

function getDataStrategy(currentOption, cardType, chartType) {
  const property = `${cardType}${chartType}`;

  return (seriesStrategies[property]
    && seriesStrategies[property](parseChartRefToOptions(currentOption)))
    || seriesStrategies.default(parseChartRefToOptions(currentOption));
}

// eslint-disable-next-line func-names
export const useSeries = function (chartRef, chartType, cardType = SIMPLE_CARD) {
  const [chartSeries, setChartSeries] = useState(null);

  useEffect(() => {
    if (chartRef.current) {
      const series = getDataStrategy(chartRef.current, cardType, chartType);
      const seriesChanged = (JSON.stringify(chartSeries) !== JSON.stringify(series));
      if (series && seriesChanged) {
        setChartSeries(series);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, chartSeries, chartType]);

  return chartSeries;
};
